import './style.scss';

function RadioButton({
  id,
  name,
  labelIconSrc,
  labelText,
  value,
  checked,
  helpIconSrc,
  helpText,
  className,
  onChange,
}: {
  id: string;
  name: string;
  labelIconSrc?: string;
  labelText: string;
  value: string;
  checked: boolean;
  helpIconSrc?: string;
  helpText?: string;
  className?: string;
  onChange?: (value: string) => void;
}) {
  return (
    <div className={`form-check ${helpText ? 'flex-column' : ''} ${className ?? ''}`}>
      <input
        type="radio"
        id={id}
        name={name}
        className="form-check-input"
        aria-describedby={helpText ? `${id}-help-text` : undefined}
        value={value}
        checked={checked}
        onChange={(event) => {
          onChange?.(event.target.value);
        }}
      />
      <label className="form-check-label fw-normal" htmlFor={id}>
        {labelIconSrc && <img src={labelIconSrc} alt="" className="radio-button__label-icon me-1" />}
        {labelText}
      </label>
      {helpText && (
        <small id={`${id}-help-text`} className="d-block radio-button__help-text">
          {helpIconSrc && <img src={helpIconSrc} alt="" className="radio-button__help-icon me-1" />}
          {helpText}
        </small>
      )}
    </div>
  );
}

export default RadioButton;
